import { Typography } from '@material-ui/core'

import { GuiddeLoad, PageTitle, DictionaryList, NewDictionary } from 'UI/Components'

import { useDictionary } from 'hooks'

export const DictionaryTab = () => {
    const {
        dictionary,
        isLoading,
        dictionariesTypes,
        languageOptions,
        deletePhrase,
        createPhrase
    } = useDictionary()

    if (isLoading) return <GuiddeLoad />

    return (
        <>
            <PageTitle text="Dictionary" />
            <Typography style={{ fontSize: '14px', marginTop: '-10px' }}>
                Improve your Guidde's transcription and search experience by adding words or phrases
                used frequently to your organizational dictionary
            </Typography>
            <NewDictionary
                // @ts-ignore JS file
                isLoading={isLoading}
                dictionariesTypes={dictionariesTypes}
                languageOptions={languageOptions}
                createPhrase={createPhrase}
            />
            <DictionaryList
                // @ts-ignore JS file
                dictionary={dictionary}
                languageOptions={languageOptions}
                deletePhrase={deletePhrase}
            />
        </>
    )
}
